<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">🏢</span>
            <span>Machines by Floor</span>
        </h2>
        <apexchart type="bar" height="250" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
export default {
    name: "VendingMachineByFloor",
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: false,
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '45%',
                        distributed: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                },
                xaxis: {
                    categories: [],
                    labels: {
                        rotate: -45,
                    },
                },
                yaxis: {
                    title: {
                        text: 'No of Machines',
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `${val} Machines`;
                        },
                    },
                },
                colors: ['#264653', '#2A9D8F', '#E9C46A', '#F4A261', '#7B6F9D'],
            },
        };
    },
    watch: {
        data: {
            handler(newData) {

                if (!Array.isArray(newData)) return;

                const machinesByFloor = {};

                newData.forEach(vendor => {
                    vendor.machines.forEach(machine => {
                        machinesByFloor[machine.floor] = (machinesByFloor[machine.floor] || 0) + 1;
                    });
                });

                const result = Object.entries(machinesByFloor).map(([floor, count]) => ({
                    floor,
                    count,
                }));

                const values = result.map(item => item.count);
                const categories = result.map(item => item.floor);

                this.series = [
                    {
                        name: 'Vending Machine',
                        data: values,
                    },
                ];
                this.chartOptions = {
                    ...this.chartOptions,
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        categories,
                        colors: this.chartOptions.colors.slice(0, categories.length),
                    },
                };
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>